<pm-toast ShowToast="ShowToast" 
          (OnClosed)="Close(undefined)">
    <div style="width: 300px">
        You have a new toast message!
    </div>
    
</pm-toast>


// WEBPACK FOOTER //
// C:/Users/jjarvis/projects/pm-controls/test/views/home/toast/message-toast.html